function roundMoney(n) {
  return Math.round((Number(n) || 0) * 100) / 100;
}

function unitPrice(item) {
  if (item.discountedPrice != null && item.discountedPrice !== '') {
    return Number(item.discountedPrice) || 0;
  }
  return Number(item.price) || 0;
}

/**
 * Normalize a quote line and compute lineTotal + margin.
 * Margin amount = selling − cost; margin % = amount / selling × 100.
 */
function calcLine(item) {
  const qty = Math.max(1, Number(item.qty) || 1);
  const price = Number(item.price) || 0;

  // Discounted defaults to list price when unset (never leave as blank/0 by accident)
  let discounted;
  if (item.discountedPrice != null && item.discountedPrice !== '') {
    discounted = Number(item.discountedPrice);
    if (Number.isNaN(discounted)) discounted = price;
  } else {
    discounted = price;
  }

  let cost;
  if (item.costPrice != null && item.costPrice !== '') {
    cost = Number(item.costPrice);
    if (Number.isNaN(cost)) cost = undefined;
  }

  const selling = discounted;
  const lineTotal = roundMoney(qty * selling);

  let margin;
  let marginAmount;
  if (cost != null && selling > 0) {
    marginAmount = roundMoney(selling - cost);
    margin = roundMoney((marginAmount / selling) * 100);
  }

  return {
    ...item,
    qty,
    price,
    discountedPrice: discounted,
    costPrice: cost,
    lineTotal,
    margin,
    marginAmount,
  };
}

function normalizeItems(items) {
  return (items || []).map(calcLine);
}

function calcQuoteTotals(items, bulkDiscountPct = 0, shipping = 0, shippingAdditional = 0) {
  const normalized = normalizeItems(items);
  // List (catalog) vs quoted merchandise — bulk % is ADDITIONAL on quoted subtotal.
  const listSubtotal = roundMoney(
    normalized.reduce((s, i) => s + (Number(i.price) || 0) * (Number(i.qty) || 1), 0),
  );
  const subtotal = roundMoney(normalized.reduce((s, i) => s + (Number(i.lineTotal) || 0), 0));
  const lineDiscountAmount = roundMoney(Math.max(0, listSubtotal - subtotal));
  const discountAmount = roundMoney(subtotal * ((Number(bulkDiscountPct) || 0) / 100));
  const afterDiscount = Math.max(0, subtotal - discountAmount);
  // Tax is calculated by Ecwid at checkout — quote totals stay ex-tax.
  const taxAmount = 0;
  const total = roundMoney(
    afterDiscount + (Number(shipping) || 0) + Math.max(0, Number(shippingAdditional) || 0),
  );
  return {
    items: normalized,
    listSubtotal,
    subtotal,
    lineDiscountAmount,
    discountAmount,
    taxAmount,
    total,
  };
}

export { calcQuoteTotals, calcLine, normalizeItems, roundMoney, unitPrice };
